let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("bFS2f"), load("eMnEL")]).then(() => parcelRequire('gFN1F'));